<template>
    <Loading
        :is-loading="data.isLoading"
        :text="data.processingText"
    />
</template>

<script setup>
import { computed, reactive } from 'vue';
import { postRedirectAccount } from '@/apis/redirect';
import { useRoute, useRouter } from 'vue-router';
import { openPopup, openPopupCatchMessage } from '@/utils/vfmUtils';
import { postMemberVerifySubmit } from '@/apis/confirmAddrPhoneEmail';
import { useStore } from 'vuex';
import { postVerifySubmitNotify } from '@/apis/eNotifyPromo';
import routeName from '@/router/constant';

const store = useStore();
const route = useRoute();
const router = useRouter();

const userId = computed(() => store?.state?.permissions?.userInfo?.id || '');
const param = computed(() => store?.state?.permissions?.userInfo?.param || '');
const eNotifyUserId = computed(() => store.state?.eNotify?.user?.id || '');
const callBackParam = computed(() => route?.query?.callBackParam || store?.state?.permissions?.callBackParam);
const data = reactive({
    isLoading: true,
    processingText: '登入檢核中...',
    callBackParam: callBackParam.value,
    callBackPath: 'external',

});

const redirectAccount = () => {
    const request = {
        callBackParam: data.callBackParam,
        callBackPath: data.callBackPath,
    };
    postRedirectAccount(request).then(res => {
        if (res.data?.redirectUrl) {
            window.location.href = res.data.redirectUrl;
        } else if (res.data?.transactionType === 'PS_LOGIN') {
            psLogin();
        } else if (res.data?.transactionType === 'OWS_LOGIN') {
            owsLogin();
        }
    }).catch(err => {
        openPopup(err.data.errorMessage, backPage);
        store.dispatch('permissions/setCallBackParam', '');
    });
};
const psLogin = () => {
    const loginData = {
        id: userId.value,
        myId: '',
        password: '',
        verifyCode: '',
        token: param.value,
        callBackParam: data.callBackParam,
    };
    postMemberVerifySubmit(loginData).then(res => {
        store.dispatch('permissions/setCallBackParam', '');
        const token = res.data.ssoParam;
        const path = process.env.VUE_APP_API_PATH;
        const baseUrl = `${window.location.origin}${path}`;
        window.location.href = `${baseUrl}/ssoLogin?param=${token}`;
    }).catch(err => {
        openPopupCatchMessage(err, backPage);
    }).finally(() => {
        store.dispatch('permissions/setCallBackParam', '');
    });
};

const owsLogin = () => {
    const loginData = {
        myId: eNotifyUserId.value,
        password: '',
        verifyCode: '',
        callBackParam: data.callBackParam,
    };
    postVerifySubmitNotify(loginData).then(res => {
        if (res.data.overYearLimit) {
            router.push({
                name: routeName.ENOTIFY_OVER_YEAR_LIMIT,
            });
        } else {
            store.dispatch('permissions/setCallBackParam', '');
            router.push({
                name: routeName.ENOTIFY_SELECT_EMAIL,
            });
        }
    }).catch(err => {
        openPopupCatchMessage(err, backPage);
    }).finally(() => {
        store.dispatch('permissions/setCallBackParam', '');
    });
};
const backPage = () => {
    router.replace({
        name: routeName.NO_AUTH,
        query: null,
    });
};

if (route?.query?.callBackParam) {
    store.dispatch('permissions/setCallBackParam', route?.query?.callBackParam);
    router.replace({
        name: routeName.REDIRECT_ACCOUNT,
        query: null,
    });
}

if (!callBackParam.value) {
    backPage();
} else {
    redirectAccount();
}

</script>
